// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"MaximizeEnergy_TheComp__VvuSm"};